import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import RadialGradient from '@bubble-ui/primitive-radial-gradient';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationEnterPin = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationEnterPin',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_radial_21134_70035)",
    fillRule: "evenodd",
    d: "m24.71 45.45.16-20.78S27.88 3.21 51.35 2.43c20.12.5 25.34 16.28 25.77 22.4l.18 21.14-15.44-.08s.17-14.62-.1-18.94c-.23-3.64-2.29-9.34-10.94-9.34-7.77 0-10.66 5.65-10.94 9.18-.37 4.57.01 18.66.01 18.66H24.71Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#5B71F3",
    fillRule: "evenodd",
    d: "M24.753 43.19v-3.86H39.75v4.29l-14.997-.43ZM61.913 43.19v-3.86H77.24v4.29l-15.327-.43Z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_linear_21134_70035)",
    fillRule: "evenodd",
    d: "M16.91 74.82c.05 3.3 2.33 5.83 2.33 5.83s5.91 8.45 8.51 11.11c2.61 2.67 6.27 3.03 6.27 3.03s29.33.03 33.78-.05c4.07-.07 4.2-.08 6.61-3.3 0 0 6.76-8.88 8.39-10.84 2.34-2.8 2.3-5.76 2.3-5.76V45.15c0-1.52-1.25-2.76-2.79-2.76l-62.64-.01c-1.54 0-2.8 1.24-2.79 2.76l.03 29.68Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#3A3A3A",
    d: "M44.07 71.26a4.95 4.95 0 1 0 0-9.9 4.95 4.95 0 0 0 0 9.9ZM57.93 71.26a4.95 4.95 0 1 0 0-9.9 4.95 4.95 0 0 0 0 9.9ZM71.79 71.26a4.95 4.95 0 1 0 0-9.9 4.95 4.95 0 0 0 0 9.9ZM30.21 71.26a4.95 4.95 0 1 0 0-9.9 4.95 4.95 0 0 0 0 9.9Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(RadialGradient, {
    id: "paint0_radial_21134_70035",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(178.619 25.396 15.136) scale(26.719 27.0238)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.145,
    stopColor: "#5B71F3"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#5EE5FE"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_21134_70035",
    x1: 107.422,
    x2: -1.991,
    y1: -22.593,
    y2: 139.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.375,
    stopColor: "#5EE2FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.721,
    stopColor: "#5B71F3"
  }))));
};
ColoredIllustrationEnterPin.displayName = 'ColoredIllustrationEnterPin';
export default withProvisionalOverrideFromContext(ColoredIllustrationEnterPin);
//# sourceMappingURL=index.js.map